import { useI18n } from '../../i18n'
import {
   closeSyncKeyEditModal,
   isSyncKeyEditModalOpen,
   saveSyncKeyEdit,
   setSyncKeyInput,
   stopSyncFromEditModal,
   syncKeyEditError,
   syncKeyInput,
} from '../../state/syncKeyEditStore'
import FieldLabel from '../ui/FieldLabel'
import TextInput from '../ui/TextInput'
import EditEntryModal from './EditEntryModal'

/**
 * Renders the sync key edit modal: switch to another key, or stop syncing on this
 * device.
 *
 * @returns The modal element.
 */
const SyncKeyEditModal = () => {
   const t = useI18n()

   return (
      <EditEntryModal
         id="sync-key-edit-modal"
         open={isSyncKeyEditModalOpen()}
         title={t('Edit sync key')}
         error={syncKeyEditError()}
         saveId="sync-key-edit-save-btn"
         cancelId="sync-key-edit-cancel-btn"
         onSave={saveSyncKeyEdit}
         onCancel={closeSyncKeyEditModal}
         onDelete={stopSyncFromEditModal}
         deleteId="sync-key-edit-stop-btn"
         deleteLabel={t('Stop syncing')}
      >
         <div>
            <FieldLabel for="sync-key-edit-input">{t('Synchronization Key')}</FieldLabel>
            <TextInput
               id="sync-key-edit-input"
               type="text"
               class="font-mono"
               value={syncKeyInput()}
               onInput={event => setSyncKeyInput(event.currentTarget.value)}
               autocomplete="off"
               spellcheck={false}
            />
            <p class="mt-1 text-xs text-ink-muted">
               {t(
                  'Switching to another key loads the data saved under it on this device. Your current data stays saved under this key.',
               )}
            </p>
         </div>
      </EditEntryModal>
   )
}

export default SyncKeyEditModal
